export const links = {
  mobile: "https://rgcams.com/landing/click/?AFNO=1-10",
  desktop: "https://rgcams.com/landing/click/?AFNO=1-3",
};
